export class FieldActivity {
  Id: number;
  RecordId: number;
  ActivityName: string;
  CreatedBy: string;
  CreatedDate: string;
  IsActive: boolean;
  IsArchived: boolean;
  IsDeleted: boolean;
  LaborCategoryId: number;
  FIPSStateId: number;
  ModifiedBy: number;
  ModifiedDate: string;
  ProjectId: number;
  TaskId: number;

  constructor(obj?: Partial<FieldActivity>) {
    if (obj) {
      Object.assign(this, obj);
    } else {
      throw Error('Object cannot be null');
    }
  }
}
